import type { ReactElement } from 'react';
import type { LinkProps } from '@mui/material';
import { Link } from '@mui/material';
import { isExternalLink } from '@noah-labs/fe-shared-ui-components';
import type { Maybe } from '../../../generated/types';
import { LocalizedLink } from '../i18n/LocalizedLink';

type PpNavigationItem = Omit<LinkProps, 'href' | 'sx'> & {
  href: Maybe<string> | undefined;
};

export function NavigationItem({ children, href, ...rest }: PpNavigationItem): ReactElement | null {
  if (!href) {
    return null;
  }

  if (isExternalLink(href)) {
    return (
      <Link
        href={href}
        target="_blank"
        underline="none"
        {...rest}
        sx={{ ':hover': { textDecoration: 'underline' } }}
      >
        {children}
      </Link>
    );
  }

  return (
    <LocalizedLink
      href={href}
      underline="none"
      {...rest}
      sx={{ ':hover': { textDecoration: 'underline' } }}
    >
      {children}
    </LocalizedLink>
  );
}
